import { ListPlaceholder, type Props as ListPlaceholderProps } from './components/ListPlaceholder'
import { NoEntries as Illustration } from './components/illustrations'

type Props = Omit<ListPlaceholderProps, 'illustration' | 'testId'>

export function NoEntries(props: Props) {
  return <ListPlaceholder {...props} testId="list-no-entries" illustration={<Illustration />} />
}
